/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayingCreator } from './PlayingCreator';
import {
    PlayingCreatorFromJSON,
    PlayingCreatorFromJSONTyped,
    PlayingCreatorToJSON,
    PlayingCreatorToJSONTyped,
} from './PlayingCreator';

/**
 * 
 * @export
 * @interface GetDropPlayingResponse
 */
export interface GetDropPlayingResponse {
    /**
     * 
     * @type {Array<PlayingCreator>}
     * @memberof GetDropPlayingResponse
     */
    creators: Array<PlayingCreator>;
    /**
     * True when the title names no platform categories, so coverage cannot be resolved. Distinct from "nobody is live".
     * @type {boolean}
     * @memberof GetDropPlayingResponse
     */
    unconfigured: boolean;
}

/**
 * Check if a given object implements the GetDropPlayingResponse interface.
 */
export function instanceOfGetDropPlayingResponse(value: object): value is GetDropPlayingResponse {
    if (!('creators' in value) || value['creators'] === undefined) return false;
    if (!('unconfigured' in value) || value['unconfigured'] === undefined) return false;
    return true;
}

export function GetDropPlayingResponseFromJSON(json: any): GetDropPlayingResponse {
    return GetDropPlayingResponseFromJSONTyped(json, false);
}

export function GetDropPlayingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDropPlayingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'creators': ((json['creators'] as Array<any>).map(PlayingCreatorFromJSON)),
        'unconfigured': json['unconfigured'],
    };
}

export function GetDropPlayingResponseToJSON(json: any): GetDropPlayingResponse {
    return GetDropPlayingResponseToJSONTyped(json, false);
}

export function GetDropPlayingResponseToJSONTyped(value?: GetDropPlayingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creators': ((value['creators'] as Array<any>).map(PlayingCreatorToJSON)),
        'unconfigured': value['unconfigured'],
    };
}

